/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersassignhelp2Inputs */

const en_partnersassignhelp2 = /** @type {(inputs: Partnersassignhelp2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For introductions where nobody used the link. A business belongs to at most one partner; assigning it here replaces an earlier assignment.`)
};

const de_partnersassignhelp2 = /** @type {(inputs: Partnersassignhelp2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Vermittlungen ohne Link. Ein Betrieb gehört zu höchstens einem Partner; eine Zuordnung hier ersetzt die bisherige.`)
};

/**
* | output |
* | --- |
* | "For introductions where nobody used the link. A business belongs to at most one partner; assigning it here replaces an earlier assignment." |
*
* @param {Partnersassignhelp2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersassignhelp2 = /** @type {((inputs?: Partnersassignhelp2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersassignhelp2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersassignhelp2(inputs)
	return de_partnersassignhelp2(inputs)
});
export { partnersassignhelp2 as "partnersAssignHelp" }